<!-- eslint-disable vue/no-deprecated-dollar-listeners-api -->

<template>
  <div class="page-content-fw-wrapper">
    <div class="page-content-fw-wrapper-inner">
      <!-- Flexible Work Header -->
      <header class="page-header-fw" role="banner">
        <div class="fw-header-left">
          <router-link :to="{ name: 'apps' }">
            <img class="raise-logo" :src="themeImage('raise-text-logo.svg')" alt="Raise" />
          </router-link>

          <div v-if="props.title" class="d-flex align-items-center">
            <ol class="breadcrumb page-breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'talent-pool' }">Dashboard</router-link>
              </li>
              <li v-if="props.title" class="breadcrumb-item active">{{ props.title }}</li>
            </ol>
          </div>
        </div>
        <div v-if="!props.title" class="fw-header-tabs">
          <router-link
            :class="{ 'fw-header-tab': true, 'tab--active': $route.name === 'talent-pool-map' }"
            :to="{ name: 'talent-pool-map' }"
          >
            <span>
              <svg
                class="mr-2"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.66602 8.12484C6.66602 6.2865 8.16102 4.7915 9.99935 4.7915C11.8377 4.7915 13.3327 6.2865 13.3327 8.12484C13.3327 9.96317 11.8377 11.4582 9.99935 11.4582C8.16102 11.4582 6.66602 9.96317 6.66602 8.12484ZM8.33268 8.12484C8.33268 9.044 9.08018 9.7915 9.99935 9.7915C10.9185 9.7915 11.666 9.044 11.666 8.12484C11.666 7.20567 10.9185 6.45817 9.99935 6.45817C9.08018 6.45817 8.33268 7.20567 8.33268 8.12484Z"
                  fill="currentColor"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.99935 1.0415C11.8918 1.0415 13.6693 1.77817 15.0085 3.1165C16.346 4.454 17.0827 6.23234 17.0827 8.12484C17.0827 14.1148 10.7468 18.619 10.4768 18.8073C10.3335 18.9073 10.166 18.9582 9.99935 18.9582C9.83268 18.9582 9.66518 18.9073 9.52185 18.8073C9.25185 18.619 2.91602 14.1148 2.91602 8.12484C2.91602 6.23234 3.65268 4.454 4.99102 3.1165C6.32852 1.77817 8.10685 1.0415 9.99935 1.0415ZM4.58268 8.12484C4.58268 12.379 8.59352 15.9548 9.99852 17.0765C11.4035 15.9532 15.416 12.3682 15.416 8.12484C15.416 6.67817 14.8527 5.31734 13.8302 4.29484C12.806 3.2715 11.446 2.70817 9.99935 2.70817C8.55268 2.70817 7.19268 3.27234 6.16935 4.29484C5.14602 5.31734 4.58268 6.67817 4.58268 8.12484Z"
                  fill="currentColor"
                />
              </svg>
              Talent
            </span>
          </router-link>
          <router-link
            :class="{ 'fw-header-tab': true, 'tab--active': $route.name === 'talent-pool' }"
            :to="{ name: 'talent-pool' }"
          >
            <span
              ><svg
                class="mr-2"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.75 14.5V17.75H19.25V14.5H4.75ZM2.75 14.25C2.75 13.2835 3.5335 12.5 4.5 12.5H19.5C20.4665 12.5 21.25 13.2835 21.25 14.25V18C21.25 18.9665 20.4665 19.75 19.5 19.75H4.5C3.5335 19.75 2.75 18.9665 2.75 18V14.25Z"
                  fill="currentColor"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.75 6.25V9.5H19.25V6.25H4.75ZM2.75 6C2.75 5.0335 3.5335 4.25 4.5 4.25H19.5C20.4665 4.25 21.25 5.0335 21.25 6V9.75C21.25 10.7165 20.4665 11.5 19.5 11.5H4.5C3.5335 11.5 2.75 10.7165 2.75 9.75V6Z"
                  fill="currentColor"
                />
              </svg>
              Dashboard
            </span>
          </router-link>
          <router-link
            :class="{ 'fw-header-tab': true, 'tab--active': $route.name === 'talent-pool-schedule' }"
            :to="{ name: 'talent-pool-schedule', locationId }"
          >
            <span>
              <svg
                class="mr-2"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M17.5 2.25C17.5 1.69772 17.0523 1.25 16.5 1.25C15.9477 1.25 15.5 1.69772 15.5 2.25V2.75H8.5V2.25C8.5 1.69772 8.05228 1.25 7.5 1.25C6.94772 1.25 6.5 1.69772 6.5 2.25V2.75H4.5C3.5335 2.75 2.75 3.5335 2.75 4.5V19.5C2.75 20.4665 3.5335 21.25 4.5 21.25H19.5C20.4665 21.25 21.25 20.4665 21.25 19.5V4.5C21.25 3.5335 20.4665 2.75 19.5 2.75H17.5V2.25ZM19.25 7.25V4.75H17.5V5.25C17.5 5.80228 17.0523 6.25 16.5 6.25C15.9477 6.25 15.5 5.80228 15.5 5.25V4.75H8.5V5.25C8.5 5.80228 8.05228 6.25 7.5 6.25C6.94772 6.25 6.5 5.80228 6.5 5.25V4.75H4.75V7.25H19.25ZM4.75 9.25H19.25V19.25H4.75V9.25Z"
                  fill="currentColor"
                />
              </svg>
              Schedule
            </span>
          </router-link>
        </div>
        <div class="fw-header-right">
          <!-- <router-link :to="{ name: 'talent-pool-settings' }" class="fw-header-company">
            <div class="fw-header-company-info">
              <span v-if="currentLocation" class="company-name">{{ currentLocation.name }}</span>
              <span v-if="!currentLocation" class="company-name">Loading...</span>
              <div class="company-rating">
                <span>3<span class="mx-1">/</span>5</span>
                <svg
                  class="ml-1"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.425 9.13125C22.3311 8.83592 22.1502 8.57585 21.9059 8.38513C21.6617 8.19441 21.3655 8.08195 21.0562 8.0625L15.4875 7.67813L13.425 2.475C13.3124 2.1885 13.1163 1.94241 12.8623 1.76858C12.6082 1.59475 12.3078 1.50118 12 1.5C11.6921 1.50118 11.3917 1.59475 11.1377 1.76858C10.8836 1.94241 10.6876 2.1885 10.575 2.475L8.47497 7.70625L2.94372 8.0625C2.63482 8.08321 2.33924 8.19614 2.09522 8.38668C1.8512 8.57722 1.66997 8.83659 1.57497 9.13125C1.47742 9.43043 1.47172 9.75197 1.55861 10.0544C1.6455 10.3569 1.821 10.6263 2.06247 10.8281L6.31872 14.4281L5.0531 19.4062C4.96553 19.743 4.98129 20.0983 5.09832 20.426C5.21536 20.7537 5.42826 21.0386 5.70935 21.2438C5.98219 21.4396 6.30726 21.5495 6.64295 21.5596C6.97864 21.5696 7.30969 21.4792 7.59372 21.3L11.9906 18.5156H12.0093L16.7437 21.5062C16.9866 21.6641 17.2697 21.7487 17.5593 21.75C17.7958 21.7481 18.0287 21.6921 18.2402 21.5861C18.4516 21.4802 18.6359 21.3272 18.779 21.1389C18.922 20.9505 19.02 20.7319 19.0654 20.4998C19.1107 20.2677 19.1022 20.0283 19.0406 19.8L17.7 14.3531L21.9375 10.8281C22.1789 10.6263 22.3544 10.3569 22.4413 10.0544C22.5282 9.75197 22.5225 9.43043 22.425 9.13125Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
            </div>
            <img class="company-logo" :src="state.company.logo_url" :alt="`${state.company.name} Logo`" />
          </router-link> -->
        </div>
        <div class="mobile-header">
          <LocationSelector />
          <div class="buttons">
            <b-button
              :to="{ name: 'talent-pool-settings', params: { locationId } }"
              class="aligned-btn"
              variant="outline-primary"
            >
              Manage your site
            </b-button>
            <b-button v-b-modal="'add-shift-modal'" variant="primary">
              <font-awesome-icon :icon="['fal', 'plus']" class="mr-2" />Add shift
            </b-button>
          </div>
        </div>
      </header>

      <!-- Main -->
      <main id="js-page-content" role="main" class="page-content-fw streams">
        <div class="page-content-fw-inner">
          <slot></slot>
        </div>
      </main>

      <!-- Mobile nav -->
      <footer class="mobile-footer">
        <router-link
          :class="{ 'fw-footer-tab': true, 'tab--active': $route.name === 'talent-pool' }"
          :to="{ name: 'talent-pool', params: { locationId } }"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.75 14.5V17.75H19.25V14.5H4.75ZM2.75 14.25C2.75 13.2835 3.5335 12.5 4.5 12.5H19.5C20.4665 12.5 21.25 13.2835 21.25 14.25V18C21.25 18.9665 20.4665 19.75 19.5 19.75H4.5C3.5335 19.75 2.75 18.9665 2.75 18V14.25Z"
              fill="currentColor"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.75 6.25V9.5H19.25V6.25H4.75ZM2.75 6C2.75 5.0335 3.5335 4.25 4.5 4.25H19.5C20.4665 4.25 21.25 5.0335 21.25 6V9.75C21.25 10.7165 20.4665 11.5 19.5 11.5H4.5C3.5335 11.5 2.75 10.7165 2.75 9.75V6Z"
              fill="currentColor"
            />
          </svg>
          <span>Dashboard</span>
        </router-link>
        <router-link
          :class="{ 'fw-footer-tab': true, 'tab--active': $route.name === 'talent-pool-schedule' }"
          :to="{ name: 'talent-pool-schedule' }"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.5 2.25C17.5 1.69772 17.0523 1.25 16.5 1.25C15.9477 1.25 15.5 1.69772 15.5 2.25V2.75H8.5V2.25C8.5 1.69772 8.05228 1.25 7.5 1.25C6.94772 1.25 6.5 1.69772 6.5 2.25V2.75H4.5C3.5335 2.75 2.75 3.5335 2.75 4.5V19.5C2.75 20.4665 3.5335 21.25 4.5 21.25H19.5C20.4665 21.25 21.25 20.4665 21.25 19.5V4.5C21.25 3.5335 20.4665 2.75 19.5 2.75H17.5V2.25ZM19.25 7.25V4.75H17.5V5.25C17.5 5.80228 17.0523 6.25 16.5 6.25C15.9477 6.25 15.5 5.80228 15.5 5.25V4.75H8.5V5.25C8.5 5.80228 8.05228 6.25 7.5 6.25C6.94772 6.25 6.5 5.80228 6.5 5.25V4.75H4.75V7.25H19.25ZM4.75 9.25H19.25V19.25H4.75V9.25Z"
              fill="currentColor"
            />
          </svg>
          <span>Schedule</span>
        </router-link>
      </footer>
    </div>
  </div>
</template>

<script setup>
import { themeImage } from '@/Theme';
import LocationSelector from '@/pages/talent-pool/components/LocationSelector.vue';
import { useRoute } from 'vue-router/composables';

const route = useRoute();
const locationId = route.params.locationId;

const props = defineProps(['title']);
</script>

<style scoped lang="scss">
.page-content-fw-wrapper {
  min-height: calc(100vh + env(safe-area-inset-bottom) * 1.25);
  background-color: var(--palette-color-default-lighten-95);
  flex-direction: row;
  width: 100%;
}

.page-content-fw-wrapper-inner {
  display: flex;
  position: relative;
  flex-direction: column;
  flex-grow: 1;
  max-width: 100vw;
  height: 100vh;
}

.page-header-fw {
  box-shadow: none;
  transition: top 0.25s;
  width: 100%;
  display: flex;
  background-color: var(--palette-color-base-white);
  border-bottom: 1px solid var(--palette-color-default-lighten-90);
  align-items: center;
  height: 83px;
}

.fw-header-left {
  flex: 1;
  display: flex;
  padding: 2rem 1.5rem;
}

.fw-header-tabs {
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 100%;
}

.fw-header-right {
  flex: 1;
  padding: 0 2rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.fw-header-company {
  gap: 1rem;
  display: flex;
}

.mobile-header {
  display: none;
  width: 100%;
}

.mobile-header .buttons {
  display: flex;
  gap: 0.75rem;
}

.user-img {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: var(--palette-color-brand-primary);

  .icon {
    height: 100%;
    width: 100%;
  }

  > [class*='fa-']:first-child {
    color: var(--palette-color-base-white) !important;
  }
}

.breadcrumb-item a {
  color: var(--palette-color-default-lighten-30);
  transition: 0.2s;
}

.breadcrumb-item a:hover {
  color: var(--palette-color-default);
}

.breadcrumb-item.active {
  color: var(--palette-color-brand-primary);
}

@media (max-width: 900px) {
  .mobile-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-right: 1rem;
  }

  .page-header-fw {
    border-bottom: none;
  }

  .fw-header-left {
    display: none;
  }

  .fw-header-tabs {
    display: none;
  }

  .fw-header-right {
    display: none;
  }

  .fw-header-company {
    flex-direction: row-reverse;
  }
}

.fw-header-tab {
  display: flex;
  align-items: center;
  color: var(--palette-color-default);
  padding: 0 1rem;
  transition: all 0.1s ease-out;
  cursor: default;

  &:not(.tab--active):hover {
    cursor: pointer;
    background: linear-gradient(var(--palette-color-base-white) 60%, var(--palette-color-core-1-lighten-90));
    transition: all 0.1s ease-out;
  }
}

.fw-header-tab.tab--active {
  color: var(--palette-color-brand-primary-darken-10);
  border-bottom: 4px solid var(--palette-color-brand-primary-darken-10);

  span {
    margin-bottom: -4px;
  }

  img {
    color: var(--palette-color-brand-primary-darken-10);
    height: 20px;
    width: 20px;
  }
}

.fw-header-company-info {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
}

@media (max-width: 900px) {
  .fw-header-company-info {
    align-items: flex-start;
  }
}

.fw-header-company-info .company-name {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: -0.02em;
  text-align: left;
  color: var(--palette-color-default);
}

.fw-header-company-info .company-rating {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.01em;
  text-align: left;
  color: var(--palette-color-default-lighten-20);
  display: flex;
  align-items: center;
}

.company-logo {
  height: 60px;
  width: 60px;
  object-fit: contain;
  border: 1px solid var(--palette-color-default-lighten-90);
  border-radius: 50%;
}

.fw-header-company-info .company-rating svg {
  height: 16px;
  width: 16px;
  color: var(--palette-color-warning);
}

.page-content-fw {
  overflow-x: hidden;
  width: 100%;
  height: 100%;
}

.page-content-fw-inner {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.mobile-footer {
  display: none;
}

.fw-footer-tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--palette-color-default-lighten-50);
}

.fw-footer-tab.tab--active {
  color: var(--palette-color-core-1);

  img {
    color: var(--palette-color-core-1);
    height: 20px;
    width: 20px;
  }
}

@media (max-width: 900px) {
  .page-content-fw {
    margin-bottom: 56px;
  }

  .mobile-footer {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 56px;
    box-shadow: 0px 2px 10px 0px rgba(34, 40, 47, 0.1), 0px 0px 2px 0px rgba(34, 40, 47, 0.05);
    background-color: var(--palette-color-base-white);
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    padding: 0.5rem 1.5rem;
  }
}

.header-icon {
  cursor: pointer !important;
}

.fa {
  /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
  font-family: 'Font Awesome 5 Pro';
}

.header-icon-big svg {
  font-size: 2rem !important;
}

.company-name h3 {
  margin-bottom: 0;
}

@media (max-width: 768px) {
  .quick-search {
    visibility: hidden;
  }

  .user-menu {
    margin-top: 16px !important;
  }
}

.burger {
  color: var(--palette-color-brand-primary);
  font-size: 20px;
  text-align: left;
  padding: 0 0.5rem;
  margin-right: 1.5rem;
  appearance: none;
  background: none;
  border: none;
}

.page-header .header-icon:not(.btn):hover > [class*='fa-']:only-child,
.page-header .header-icon:not(.btn)[data-toggle='dropdown'][aria-expanded='true'] > [class*='fa-']:first-child {
  color: var(--palette-color-brand-primary) !important;
}

.header-icon:not(.btn)[data-toggle='dropdown'][aria-expanded='true']::after {
  background: var(--palette-color-brand-primary) !important;
  opacity: 0.4 !important;
  top: 0.85rem !important;
}

.raise-logo {
  margin-right: 1rem;
}
</style>
